import { useEffect, useState } from 'react';

/**
 * Cycle through a fixed list of strings on a setInterval.
 *
 * SOURCE: frontend-prod/features/draft/DraftCreationLoader.tsx:176-182
 *  - Web uses Framer Motion AnimatePresence to crossfade; we keep this
 *    plain and let DraftLoadingOverlay apply a CSS opacity transition.
 *  - Returning the current item by index (not by reference) means a
 *    re-mount restarts the rotation, which is the expected behaviour.
 *
 * Empty list returns '' and the interval is not started.
 */
export function useRotatingMessage(
  items: readonly string[],
  intervalMs: number = 2400,
): string {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    if (items.length <= 1) return;
    const id = setInterval(() => {
      setIndex((i) => (i + 1) % items.length);
    }, intervalMs);
    return () => clearInterval(id);
  }, [items, intervalMs]);

  if (items.length === 0) return '';
  return items[index % items.length];
}
